import { Component, inject } from '@angular/core';
import {LocationService} from "../administration/location/location.service";
import {ListboxModule} from "primeng/listbox";
import {SharedModule} from "primeng/api";
import {Router} from "@angular/router";
import {SimpleMessagesComponent} from "../shared/simple-messages/simple-messages.component";

@Component({
    selector: 'app-pickup-locations',
    imports: [
        ListboxModule,
        SharedModule,
        SimpleMessagesComponent
    ],
    templateUrl: './pickup-locations.component.html',
    styleUrl: './pickup-locations.component.scss'
})
export class PickupLocationsComponent {
  locationService = inject(LocationService);
  private router = inject(Router);

  chooseLocation(locationId: number) {
    void this.router.navigate(['pickup', locationId]);
  }
}
